module.exports = __webpack_public_path__ + "static/media/Whatsapp.d2be3df1.svg";